export const ZOOM_VALUE = [
  { name: 'Scale to Fit', value: 0 },
  { name: '33%', value: 0.33 },
  { name: '50%', value: 0.5 },
  { name: '66%', value: 0.66 },
  { name: '75%', value: 0.75 },
  { name: '100%', value: 1 },
  { name: '125%', value: 1.25 },
  { name: '150%', value: 1.5 }
];

export const ZOOM_CONFIG = {
  MIN: 0.01,
  MAX: 1.5,
  DECIMAL_PLACE: 2
};
